import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useRouteMatch, useLocation, useHistory } from "react-router-dom";

import cx from 'classnames';
import _ from 'lodash';

import { generateReportUrl } from 'services/report.service';
import { Modal } from "react-bootstrap";
import { FOURTEEN_DAYS } from 'constants/report.jsx';

import WorkspaceSessionAnalytics from "./components/sessionAnalytics";
import WorkspaceLeadsReportsAnalytics from "./components/leadReports";
import WorkspaceStoryboardReports from "./components/storyboardReports";
import WorkspaceAssetAnalytics from "./components/assetAnalytics";
import { getReportDatesForOption } from 'services/report.service';
import { invalidateWorkspaceReports } from "actions/workspaceReports";

import styles from './workspaceReports.module.scss';

export function TableHeaderInfo({ title, count, date }) {

  return (
    <div className={styles.tableHeaderWrapper}>
      <div className={styles.title}>
        <h5 className={styles.name}>{title}
          <span className={styles.count}>
            ({count})
          </span>
        </h5>
      </div>
    </div>
  )
}

export function ReportsModalView({ type, show, setShowModal, date, contentType }) {
  const dispatch = useDispatch();

  const [reportDate, setReportDate] = useState({
    type: FOURTEEN_DAYS,
    ...getReportDatesForOption(FOURTEEN_DAYS)
  });

  let { url } = useRouteMatch();
  const { search } = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (reportDate) {
      const updatedUrl = generateReportUrl(url, reportDate, search);
      history.replace(updatedUrl);
    }
  }, [reportDate]);

  const onClose = () => {
    dispatch(invalidateWorkspaceReports());
    setShowModal(false);
  }

  return (
    <Modal show={true} className={styles.viewAllModalContainer} backdropClassName={styles.backdrop} centered>
      {show && type === "sessionAnalytics" &&
        <WorkspaceSessionAnalytics date={date} contentType={contentType} modalView={true} />
      }
      {show && type === "storyboardReports" &&
        <WorkspaceStoryboardReports date={date} contentType={contentType} modalView={true} />
      }
      {show && type === "leadReports" &&
        <WorkspaceLeadsReportsAnalytics date={date} contentType={contentType} modalView={true} />
      }
      {show && type === "assetAnalytics" &&
        <WorkspaceAssetAnalytics date={date} contentType={contentType} modalView={true} />
      }
      <div className={styles.closeModalBtn} onClick={onClose}>
        <i className={cx(styles.icon, 'cleverstory-close')} />
      </div>
    </Modal>
  )
}

export function TableFooterInfo({ type, modalView, pagination, paginationName, onChange, data = {}, date, contentType }) {
  // const viewPorts = [{ type: "table_view", icon: '/images/reports/table.svg'}, { type: "graph_view", icon: '/images/reports/graph.svg'}, { type: "pie_chart_view", icon: '/images/reports/pie_chart.svg' },];
  const [showModal, setShowModal] = useState(false);

  const handleViewAll = () => {
    setShowModal(true);
  }

  return (
    <div className={styles.TableFooterWrapper}>
      <div className={cx({ [styles.Tableborder]: (data.length > 5) })}>
        <div className={styles.footerContainerWapper}>
          {!modalView && data && data.length > 5 &&
            <div className={styles.viewAll}>
              <button onClick={() => handleViewAll()}>View All</button>
            </div>
          }
          {modalView &&
            <div className={styles.pagination}>
              <PaginationForReports
                pagination={pagination}
                type={paginationName}
                onClick={onChange} />
            </div>
          }
          {/* <div className={styles.viewPortContainer}>
                        {viewPorts.filter(item => !disableView.includes(item.type)).map((viewport, index) => {
                        return (
                            <div key={index} className={cx(styles.viewPort, { [styles.active]: (currentChart === viewport.type) })} onClick={() => handleChartChange(viewport.type)}>
                            <img alt="leftArrowIcon" className={styles.icon} src={viewport.icon} />
                            </div>
                        )
                        })}
                    </div>  */}
        </div>
        {showModal && (
          <ReportsModalView type={type} show={showModal} setShowModal={setShowModal} date={date} contentType={contentType} />
        )}
      </div>
    </div>
  )
}

export function PaginationForReports({ pagination, onClick, type, className }) {
  const { current, totalPages, totalRecordsCount } = pagination;

  const start = (current * 20) + 1;
  const end = Math.min(start + 19, totalRecordsCount);
  const show = current >= 0 && totalPages > 1;
  
  const handlePrevious = () => {
    var page = current - 1;
    if (page >= 0) {
      onClick(page);
    }
  }

  const handleNext = () => {
    var page = current + 1;
    if (page < totalPages) {
      onClick(page);
    }
  }

  if (!show) {
    return false;
  }

  return (
    <div className={cx(styles.paginationContainer, className)}>
      <div className={cx(styles.pagination, 'paginationContent')}>
        <div className={cx(styles.paginationArrow, { [styles.disable]: (current == 0) })} onClick={handlePrevious}>
          <img alt="leftArrowIcon" className={styles.arrowIcon} src='/images/reports/left_arrow.svg' />
        </div>

        <span><span className={styles.pageNumber}>{start} - {end}</span> of <span className={styles.pageNumber}>{totalRecordsCount}</span> {type ? type : ''}</span>

        <div className={cx(styles.paginationArrow, { [styles.disable]: current >= totalPages - 1 })} onClick={handleNext}>
          <img alt="rightArrowIcon" className={styles.arrowIcon} src='/images/reports/right_arrow.svg' />
        </div>
      </div>
    </div>
  );
}